<template>
  <div v-if="props.redeemedTimes > 1" class="flex items-center text-gray-80 flex-wrap">
    <div class="flex items-center gap-1 mr-3">
      <p>{{ $t('promo.quantity.claimed') }}</p>
      <p>{{ props.redeemedTimes }}</p>
    </div>
    <div class="flex items-center gap-1">
      <p>{{ $t('promo.quantity.remaining') }}</p>
      <p>{{ props.remainTimes }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  redeemedTimes: number
  remainTimes: number
}

const props = defineProps<Props>()
</script>
